export function getRandomColor() {
  const h = Math.floor(Math.random() * 60 + 180);
  const s = Math.floor(Math.random() * 50 + 50);
  const l = Math.floor(Math.random() * 50 + 25);
  return 'hsl(' + h + ', ' + s + '%, ' + l + '%)';
}
